import React from 'react';
import { FailureStatus } from 'src/common/ui/StatusScreen';
import { useTranslation } from 'src/i18n/shim/useTranslation';

/**
 * Page shown when the bootstrap `getUserProfile` call fails.
 *
 * Rendered as a Cloudscape error Alert by {@link ../../common/ui/StatusScreen}, by the
 * {@link ./AppBootstrap} gate in place of its children, at whatever URL the user is
 * on — the failure does not move them. Purely presentational as a result: recovery is
 * the gate's job, since a reload re-issues the query and renders the app if it
 * succeeds, which is what makes "refresh this page to try again" true.
 *
 * No "reach out to the LangHub team" line, unlike
 * {@link ./PermissionsUnavailablePage}: this failure is usually the user's own session
 * or network, so a refresh is genuinely the fix rather than the first of two steps.
 */
const ProfileUnavailablePage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <FailureStatus heading={t('auth-profile-unavailable-heading')}>
      <p>{t('auth-profile-unavailable-body')}</p>
    </FailureStatus>
  );
};

export default ProfileUnavailablePage;
